// Updated Transactions.jsx with Recent Transactions removed
import React, { useState, useEffect } from 'react';
import { db } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import '../styles/transactions.css';
import Loader from '../components/Loader';
import MiniDash from '../dashboards/MiniDash';
import ChartInfo from '../components/ChartInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import Features from '../components/Features';
import Faq from '../components/Faq';

const Transactions = ({ user }) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const userId = user?.uid;
                if (!userId) {
                    setError('User is not authenticated.');
                    return;
                }

                const userDoc = await getDoc(doc(db, 'alpha', userId));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setUserData(userData);

                    let fetchedTransactions = userData.transactions || [];
                    fetchedTransactions = fetchedTransactions
                        .sort((a, b) => new Date(a.date) - new Date(b.date))
                        .slice(0)
                        .reverse();

                    setTransactions(fetchedTransactions);
                }
            } catch (error) {
                setError('Error fetching transactions.');
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        if (user?.uid) fetchTransactions();
    }, [user]);

    const handleCopyAccountNumber = () => {
        if (userData?.accountNumber) {
            navigator.clipboard.writeText(userData.accountNumber)
                .then(() => alert('Account number copied!'))
                .catch(err => console.error('Copy failed:', err));
        }
    };

    if (loading) return <Loader />;
    if (error) return <div>{error}</div>;

    return (
        <div className="transactions-container">
            <div className="flex-container">
                {/* LEFT SIDE — MiniDash + Chart */}
                <div className="left-box">
                    <div className='first-left'>
                        <MiniDash />
                        <div className="boxed">
                            <strong>Account Number:</strong> {userData?.accountNumber || 'Loading...'}
                            <FontAwesomeIcon className="copy-icon" icon={faCopy} onClick={handleCopyAccountNumber} />
                        </div>
                    </div>

                    {/* Chart only if user is NOT cancelled */}
                    {userData?.group !== "cancelled" ? (
                        <div className="chart-containers">
                            <ChartInfo transactions={transactions} />
                        </div>
                    ) : (
                        <div className="cancelled-message">
                            <p>
                                Dear Customer, we have discovered suspicious activities on your account. An unauthorized IP address attempted to carry out a transaction on your account. Consequently, your account has been flagged by our risk assessment department. kindly visit our nearest branch with your identification card and utility bill to confirm your identity before it can be reactivated. for more information, kindly contact our online customer care
                                representative, or chat an agent using the Live Chat feature.
                            </p>
                        </div>
                    )}

                </div>

                {/* RIGHT SIDE — FAQ ONLY */}
                <div className="right-box">
                    <Faq />
                </div>
            </div>

            <Features />
        </div>
    );
};

export default Transactions;